var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-select',{attrs:{"value":_vm.selectedEvent,"placeholder":_vm.$t('settings.dropDownPlaceholder'),"loading":_vm.loading},on:{"change":_vm.updateMeals}},_vm._l((_vm.events),function(event){return _c('el-option',{key:event.name,attrs:{"label":event.name,"value":event.id}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b8836b48","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/catering/EventSelection.vue
// module id = null
// module chunks = 